<template>
  <div class="behold-content-wrapper">
    <section
      class="pt-8 lg:pt-16 pb-20 container-contents lg:pb-120 font-AvenirNext"
    >
      <div>
        <Logo class="flex justify-start" />
      </div>

      <div class="mt-20 lg:mt-24">
        <div class="flex justify-center">
          <svg
            class="w-92 h-9 lg:w-188 h-74"
            viewBox="0 0 188 74"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.617 0C27.0006 0 32.0254 4.00262 32.0254 11.644C32.0254 19.2853 27.0006 23.288 17.617 23.288H7.26473V41.1784H0V0H17.617ZM17.1932 18.1331C21.4915 18.1331 24.8817 16.3743 24.8817 11.644C24.8817 6.91361 21.4915 5.15488 17.1932 5.15488H7.26473V18.1331H17.1932ZM38.2609 41.1784V0H45.4046V41.1784H38.2609ZM76.1586 30.3229L81.7888 33.8403C79.3066 39.1165 74.9478 41.603 67.9858 41.603C58.8443 41.603 52.4877 34.9926 52.4877 25.4712C52.4877 15.7072 58.4206 9.27879 67.3804 9.27879C76.4008 9.27879 81.5466 16.0105 81.365 26.017V26.3809H59.934C60.2367 33.0519 63.4453 36.9939 68.5912 36.9939C71.7998 36.9939 75.2505 35.599 76.1586 30.3229ZM67.3804 13.9485C62.9005 13.9485 60.6 17.2234 60.0551 22.7421H73.616C73.3133 16.6169 71.6787 13.9485 67.3804 13.9485ZM115.207 10.1885L103.28 25.2893L115.207 41.1784H107.215L99.5874 30.2622L91.8383 41.1784H84.3314L96.1366 25.7744L84.3314 10.1885H92.3226L99.8295 20.8015L107.7 10.1885H115.207ZM140.754 10.1885H147.958V41.1784H140.754V34.75C139.301 39.3591 136.456 41.6636 131.31 41.6636C124.651 41.6636 120.716 38.4494 120.716 31.1719V10.1885H127.92V30.2016C127.92 34.6893 129.978 36.6907 133.913 36.6907C138.575 36.6907 140.694 33.4764 140.754 28.3216V10.1885ZM168.784 22.1357C177.078 23.9551 179.984 26.7448 179.984 31.5358C179.984 37.6003 175.807 41.603 167.694 41.603C161.519 41.603 155.889 38.2068 154.981 33.4764L160.006 30.3835C160.611 34.6893 163.88 36.9939 168.118 36.9939C172.174 36.9939 173.506 35.4171 173.506 33.2339C173.506 30.5654 172.235 29.4132 167.089 28.3822C159.219 26.8054 155.889 23.9551 155.889 18.6182C155.889 13.4027 159.521 9.21814 168.481 9.1575C174.898 9.09685 179.56 12.4324 180.347 17.2234L174.898 19.2853C174.293 15.5253 171.508 13.7059 167.634 13.7059C164.122 13.7059 162.125 15.1008 162.125 17.5266C162.125 20.1344 163.214 20.9228 168.784 22.1357ZM102.5 61.5121C104.645 61.5121 106.419 63.2127 106.419 65.8693C106.419 68.5429 104.654 70.235 102.5 70.235C101.199 70.235 100.11 69.5836 99.5948 68.5344L99.5525 70.0574H97.9901V57.0618H99.6032L99.6117 63.1704C100.135 62.1467 101.216 61.5121 102.5 61.5121ZM102.145 68.8475C103.615 68.8475 104.797 67.6715 104.797 65.8693C104.797 64.0672 103.615 62.8997 102.145 62.8997C100.667 62.8997 99.4934 64.1603 99.4934 65.8693C99.4934 67.5868 100.659 68.8475 102.145 68.8475ZM108.885 61.6813L111.191 68.0268L113.53 61.6813H115.236L110.329 74H108.657L110.38 69.8458L107.095 61.6813H108.885ZM183.387 61.0066C184.662 61.0066 185.484 61.6367 185.92 62.7571V61.2691H188V69.0591C188 71.8774 186.27 72.9452 183.649 72.9452C181.692 72.9452 180.346 72.1575 179.682 70.8096L181.464 69.8642C181.954 71.2822 182.6 71.7198 183.876 71.7198C185.379 71.7198 185.92 70.7045 185.92 68.8315V67.536C185.484 68.6739 184.627 69.3216 183.317 69.3216C181.15 69.3216 179.63 67.536 179.63 65.1729C179.63 62.7745 181.167 61.0066 183.387 61.0066ZM144.236 60.9124C146.735 60.9124 148.198 62.7812 148.249 65.5924L148.249 66.0055H142.099C142.186 67.9922 143.107 69.1661 144.583 69.1661C145.504 69.1661 146.494 68.7507 146.755 67.1793L148.371 68.2268C147.658 69.7982 146.407 70.5387 144.41 70.5387C141.786 70.5387 139.962 68.5701 139.962 65.7345C139.962 62.8268 141.665 60.9124 144.236 60.9124ZM133.46 58.5058L133.46 63.1467C133.828 61.8551 134.549 61.1994 135.878 61.1994C137.64 61.1994 138.761 62.3159 138.761 64.4425V70.5387H136.855V64.5842C136.855 63.2729 136.311 62.6703 135.27 62.6703C134.037 62.6703 133.476 63.6273 133.46 65.1337V70.5387H131.554V58.5058H133.46ZM159.663 58.5058C162.478 58.5058 163.986 59.6753 163.986 61.9083C163.986 64.1412 162.478 65.3109 159.663 65.3109H156.556V70.5387H154.377V58.5058H159.663ZM167.589 58.5058V70.5387H165.187V58.5058H167.589ZM129.021 58.563V60.051H125.342V70.4492H123.272V60.051H119.542V58.563H129.021ZM172.115 61.2691V67.0459C172.115 68.3413 172.71 68.9189 173.845 68.9189C175.191 68.9189 175.803 67.9912 175.82 66.5033V61.2691H177.9V70.2144H175.82V68.3588C175.401 69.6892 174.579 70.3544 173.094 70.3544C171.172 70.3544 170.036 69.4266 170.036 67.3259V61.2691H172.115ZM183.893 62.3195C182.705 62.3195 181.849 63.4748 181.849 65.1729C181.849 66.8359 182.705 67.9912 183.893 67.9912C185.082 67.9912 185.938 66.7483 185.938 65.1729C185.938 63.5973 185.082 62.3195 183.893 62.3195ZM144.236 62.303C142.95 62.303 142.29 63.2783 142.134 64.9218H146.025C145.938 63.0976 145.469 62.303 144.236 62.303ZM159.535 60.0121H156.556V63.8044H159.535C160.825 63.8044 161.842 63.2906 161.842 61.9083C161.842 60.526 160.825 60.0121 159.535 60.0121Z"
              fill="#191919"
            />
          </svg>
        </div>

        <div class="flex w-full justify-center mt-20 lg:mt-120">
          <figure class="w-full mx-auto lg:w-10/12">
            <img
              src="../assets/images/plexus/plexus-1.png"
              alt="Screenshot of Plexus App"
            />
          </figure>
        </div>

        <div class="w-full lg:w-1/2 mt-20 lg:mt-120">
          <p class="banner-section-text xl:pr-4">
            Plexus is a web application that shows workforce representation of
            tech companies, along with diversity and inclusion commitments and
            practices. It provides a way for researchers, job seekers and
            consumers to learn about and evaluate companies. Companies using
            Plexus can update their data, compare themselves to the industry,
            and get guidance on improving internal diversity and inclusion.
          </p>
        </div>
      </div>
    </section>

    <article class="py-20 lg:py-120 text-black-dark bg-white usability-testing">
      <div class="container-contents">
        <div class="w-full lg:w-2/3 mx-auto">
          <h5 class="article-title">Context</h5>
          <p class="article-paragraph font-normal">
            The Plug is an investigative reporting and technology journalism
            organization that highlights under-served and under-reported tech
            entrepreneurs. The Plug began as a daily tech newsletter covering
            Black founders and innovators, and now provides a wealth of
            reporting and data journalism on the black tech economy.
          </p>
          <p class="article-paragraph mt-2 font-normal">
            Following recent racial unrests, companies of all types, especially
            tech companies, made commitments to black lives and black people.
            The Plug began maintaining a database of these commitments, and
            partnered with Enle Inc. to design and build a web application
            (Plexus) which shows workforce representation of tech companies,
            along with diversity and inclusion commitments and practices.
          </p>
        </div>
      </div>
    </article>

    <section
      class="py-20 lg:py-120 bg-green-lighter text-green what-unique unique-behold"
    >
      <div class="container-contents">
        <h3 class="question-section-title text-green-light">
          What’s unique about Plexus?
        </h3>
      </div>
      <!--- First Image -->
      <div
        class="flex flex-wrap justify-between items-center mt-20 lg:mt-28 px-6 lg:pl-36 lg:pr-0"
      >
        <article class="w-full lg:w-1/2">
          <div class="container lg:w-11/12">
            <h5 class="article-title pr-10">
              Companies Diversity & Inclusion (D&I) Data, Jobs, Reviews &
              Updates
            </h5>
            <p class="article-paragraph">
              Individuals can view companies; D&I data and open jobs. They can
              also review and follow companies.
            </p>
          </div>
        </article>

        <div class="w-full mx-auto flex justify-end lg:w-3/6 mt-16 lg:mt-0">
          <figure class="lg:pl-12">
            <img
              class="object-cover object-center hidden lg:flex"
              src="../assets/images/plexus/plexus-2.png"
              alt="Screenshot of Plexus App"
            />
            <img
              class="object-cover object-center flex lg:hidden"
              src="../assets/images/plexus/plexus-2-smal.png"
              alt="Screenshot of Plexus App"
            />
          </figure>
        </div>
      </div>

      <!--- Second Image -->
      <div
        class="flex flex-wrap justify-between items-center lg:pr-20 mt-120 lg:mt-60 px-6 lg:pr-20 lg:pl-0"
      >
        <div class="w-full flex justify-start lg:w-3/6 order-2 lg:order-1">
          <figure class="lg:pr-20">
            <img
              class="object-cover object-center hidden lg:flex"
              src="../assets/images/plexus/plexus-3.png"
              alt="Screenshot of Plexus App"
            />
            <img
              class="object-cover object-center flex lg:hidden"
              src="../assets/images/plexus/plexus-3-small.png"
              alt="Screenshot of Plexus App"
            />
          </figure>
        </div>

        <article
          class="w-full lg:w-1/2 flex justify-end order-1 lg:order-2 mb-16 lg:mb-0"
        >
          <div class="w-full lg:w-11/12">
            <h5 class="article-title">Diversity & Inclusion (D&I) Rankings</h5>
            <p class="article-paragraph mt-4 pr-5">
              D&I rankings show how diverse, inclusive & transparent companies
              are. Individuals viewing companies rankings can use them to
              determine how well companies are meeting D&I commitments and
              practices.
            </p>
          </div>
        </article>
      </div>

      <!--- Third Image -->
      <div
        class="flex flex-wrap justify-between items-center mt-120 lg:mt-60 px-6 lg:pl-36 lg:pr-0"
      >
        <article class="w-full lg:w-1/2">
          <div class="container lg:w-11/12">
            <h5 class="article-title pr-10">
              View & Compare Companies Diversity & Inclusion (D&I) Reports
            </h5>
            <p class="article-paragraph">
              Individuals, companies and Plexus admins can view and compare
              companies D&I reports with each other. This gives a view of how
              companies compare to each other on different aspects of workforce
              representation.
            </p>
          </div>
        </article>

        <div class="w-full flex justify-end lg:w-3/6 mt-16 lg:mt-0">
          <figure class="lg:pl-12">
            <img
              class="object-cover object-center"
              src="../assets/images/plexus/plexus-4.png"
              alt="Screenshot of Plexus App"
            />
          </figure>
        </div>
      </div>

      <!--- Fourth Image -->
      <div
        class="flex flex-wrap justify-between items-center lg:pr-20 mt-120 lg:mt-60 px-6 lg:pr-20 lg:pl-0"
      >
        <div class="w-full flex justify-start lg:w-3/6 order-2 lg:order-1">
          <figure class="lg:pr-20">
            <img
              class="object-cover object-center hidden lg:flex"
              src="../assets/images/plexus/plexus-5.png"
              alt="Screenshot of Plexus App"
            />
            <img
              class="object-cover object-center flex lg:hidden"
              src="../assets/images/plexus/plexus-5-small.png"
              alt="Screenshot of Plexus App"
            />
          </figure>
        </div>

        <article
          class="w-full lg:w-1/2 flex justify-end order-1 lg:order-2 mb-16 lg:mb-0"
        >
          <div class="w-full lg:w-11/12">
            <h5 class="article-title">
              Manage Company Data, Job Postings & Hire Diverse Candidates
            </h5>
            <p class="article-paragraph mt-4 pr-5">
              Companies can add & update their data to give accurate views of
              their workforce representation. They can also post jobs and
              benchmark themselves against their peers by comparing D&I data and
              reports.
            </p>
          </div>
        </article>
      </div>
    </section>

    <vm-back-top :bottom="100" :duration="1000" :timing="'ease'">
      <div class="back-to-top-arrow">
        <svg
          class="h-12 w-12 lg:w-79 lg:h-79"
          viewBox="0 0 79 79"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.4999 75.9411C59.6253 75.9411 75.9402 59.6263 75.9402 39.5008C75.9402 19.3754 59.6253 3.06055 39.4999 3.06055C19.3744 3.06055 3.05957 19.3754 3.05957 39.5008C3.05957 59.6263 19.3744 75.9411 39.4999 75.9411Z"
            fill="#025955"
            fill-opacity="0.24"
          />
          <path
            d="M56.9706 48.0065C55.7773 49.1936 53.8498 49.1936 52.6565 48.0065L39.5306 34.8806L26.4047 48.0065C25.1227 49.1049 23.189 48.9549 22.0906 47.673C21.1085 46.5288 21.1085 44.8368 22.0906 43.6925L37.3888 28.3943C38.5821 27.2071 40.5096 27.2071 41.7029 28.3943L57.0012 43.6925C58.1792 44.8949 58.1669 46.8224 56.9706 48.0065Z"
            fill="white"
          />
        </svg>
      </div>
    </vm-back-top>

    <section class="py-20 lg:py-120 how-we-got-here bg-white">
      <article class="container-contents">
        <h3 class="question-section-title text-gray-lighter">
          So how did we get here?
        </h3>

        <div class="bg-white mt-20 lg:mt-120">
          <div class="container mx-auto lg:w-2/3">
            <h5 class="article-title">Team & Role</h5>
            <p class="article-paragraph text-black-dark font-normal">
              Our team was made up of 1 Product Owner, 1 Product Manager, a
              Development Agency and a UX Designer (myself). I handled the UX
              and UI design for this project.
            </p>
          </div>
        </div>

        <div class="bg-white mt-20 lg:mt-120">
          <div class="container mx-auto lg:w-2/3">
            <h5 class="article-title">Plexus Users & Their Goals</h5>
            <p class="article-paragraph mt-6 lg:mt-8">
              The primary users of Plexus and their goals are:
            </p>

            <ul class="list-disc ml-4 mt-4 lg:mt-6">
              <li class="my-4 article-paragraph">
                Plexus Admins (Employees) - To enter D&I data for companies, to
                approve new company users and to approve updates made by company
                users to D&I data
              </li>
              <li class="my-4 article-paragraph">
                Consumers (Individuals) - To understand where companies stands
                on diversity and inclusion, and find jobs
              </li>
              <li class="my-4 article-paragraph">
                Companies - To share their D&I data, hire diverse candidates and
                benchmark themselves against their peers
              </li>
            </ul>
          </div>
        </div>
      </article>
    </section>

    <section
      class="py-20 lg:py-120 bg-green-lighter text-green what-unique unique-behold"
    >
      <div class="container-contents">
        <div class="container mx-auto lg:w-2/3">
          <h5 class="article-title text-green">Wireframing & Prototyping</h5>
          <p class="article-paragraph text-green font-medium">
            I created wireframes and prototypes based on the product
            requirements. The wireframes allowed us to explore the more
            challenging aspects of Plexus which were:
          </p>
        </div>
      </div>

      <!--- First Image -->
      <div
        class="flex flex-wrap justify-between items-center lg:pr-20 mt-16 lg:mt-120 px-6 lg:pr-20 lg:pl-0"
      >
        <div class="w-full flex justify-start lg:w-3/6 order-2 lg:order-1">
          <figure class="lg:pr-20">
            <img
              class="object-cover object-center hidden lg:flex"
              src="../assets/images/plexus/plexus-6.png"
              alt="Screenshot of Plexus App"
            />
            <img
              class="object-cover object-center flex lg:hidden"
              src="../assets/images/plexus/plexus-6-small.png"
              alt="Screenshot of Plexus App"
            />
          </figure>
        </div>

        <article
          class="w-full lg:w-1/2 flex justify-end order-1 lg:order-2 mb-16 lg:mb-0"
        >
          <div class="w-full lg:w-11/12">
            <p class="article-paragraph mt-4 pr-5">
              How D&I data entered and updated by company & admin users can be
              managed and kept consistent across both users side of the
              platform.
            </p>
          </div>
        </article>
      </div>

      <!--- Second Image -->
      <div
        class="flex flex-wrap justify-between items-center mt-120 lg:mt-60 px-6 lg:pl-36 lg:pr-0"
      >
        <article class="w-full lg:w-1/2">
          <div class="container lg:w-11/12">
            <p class="article-paragraph">
              How to properly structure and layout data on company D&I reports
              so its easy to digest and doesn't overwhelm viewers.
            </p>
          </div>
        </article>

        <div class="w-full flex justify-end lg:w-3/6 mt-16 lg:mt-0">
          <figure class="lg:pl-12">
            <img
              class="object-cover object-center hidden lg:flex"
              src="../assets/images/plexus/plexus-7.png"
              alt="Screenshot of Plexus App"
            />
            <img
              class="object-cover object-center flex lg:hidden"
              src="../assets/images/plexus/plexus-7-smal.png"
              alt="Screenshot of Plexus App"
            />
          </figure>
        </div>
      </div>

      <div class="container-contents mt-20 lg:mt-120">
        <div class="container mx-auto lg:w-2/3">
          <p class="article-paragraph text-green font-medium">
            We also explored how consumers can view D&I data and how admins can
            manage requests from company users.
          </p>
        </div>
      </div>
    </section>

    <article class="py-20 lg:py-120 text-black-dark bg-white usability-testing">
      <div class="container-contents">
        <div class="w-full lg:w-2/3 mx-auto">
          <h5 class="article-title">Usability Testing</h5>
          <p class="article-paragraph">
            With an acceptable wireframe and prototype, we tested out the
            customer side of Plexus with 4 participants. The findings from the
            studies were summarised in a slide deck and presented to the team.
            The summary deck also included recommendations on how to improve the
            product based on user’s feedback.
          </p>
        </div>
      </div>
    </article>

    <section
      class="py-20 lg:py-120 bg-green-lighter text-green what-unique unique-behold"
    >
      <div class="container-contents">
        <div class="container mx-auto lg:w-2/3">
          <h5 class="article-title">Visual Design, Iteration & Development</h5>
          <p class="article-paragraph font-medium">
            The visual design and prototype were generated based on the
            wireframes, recommendations from the usability tests, and The Plug’s
            brand guide. We explored different visual treatments which centered
            around:
          </p>
        </div>
      </div>

      <!--- First Image -->
      <div
        class="container-contents flex flex-wrap justify-between items-center mt-20 lg:mt-120"
      >
        <div
          class="w-full flex justify-start lg:w-3/6 order-2 lg:order-1 xl:pl-8"
        >
          <figure>
            <img
              class="object-cover object-center"
              src="../assets/images/plexus/plexus-8.png"
              alt="Screenshot of Plexus App"
            />
          </figure>
        </div>

        <article
          class="w-full lg:w-2/4 flex justify-end order-1 lg:order-2 mb-16 lg:mb-0"
        >
          <div class="w-full lg:w-10/12">
            <p class="article-paragraph font-medium mt-4 lg:pr-5">
              A simple, consistent and identical interface for entering and
              updating D&I data across companies and users' side of the Plexus
              platform.
            </p>
          </div>
        </article>
      </div>

      <!--- Second Image -->
      <div
        class="container-contents flex flex-wrap justify-between items-center mt-120 lg:mt-60 xl:pl-20 lg:pr-16"
      >
        <article class="w-full lg:w-2/4">
          <div class="container lg:w-10/12">
            <p class="article-paragraph lg:pr-5">
              An easy to understand view of companies D&I data for consumers.
            </p>
          </div>
        </article>

        <div class="w-full flex justify-end lg:w-1/2 mt-16 lg:mt-0">
          <figure>
            <img
              class="object-cover object-center"
              src="../assets/images/plexus/plexus-9.png"
              alt="Screenshot of Plexus App"
            />
          </figure>
        </div>
      </div>

      <!--- Third Image -->
      <div
        class="container-contents flex flex-wrap justify-between items-center mt-120 lg:mt-60"
      >
        <div
          class="w-full flex justify-start lg:w-3/6 order-2 lg:order-1 xl:pl-8"
        >
          <figure>
            <img
              class="object-cover object-center"
              src="../assets/images/plexus/plexus-10.png"
              alt="Screenshot of Plexus App"
            />
          </figure>
        </div>

        <article
          class="w-full lg:w-2/4 flex justify-end order-1 lg:order-2 mb-16 lg:mb-0"
        >
          <div class="w-full lg:w-10/12">
            <p class="article-paragraph mt-4 pr-5">
              A simple and clean report structure with consistent spacing and
              colour treatments for digestibility
            </p>
          </div>
        </article>
      </div>

      <!--- Fourth Image -->
      <div
        class="container-contents flex flex-wrap justify-between items-center mt-120 lg:mt-60 xl:pl-20 lg:pr-16"
      >
        <article class="w-full lg:w-2/4">
          <div class="container lg:w-10/12">
            <p class="article-paragraph lg:pr-5">
              A seamless representation of D&I data when comparing companies.
            </p>
          </div>
        </article>

        <div class="w-full flex justify-end lg:w-1/2 mt-16 lg:mt-0">
          <figure>
            <img
              class="object-cover object-center"
              src="../assets/images/plexus/plexus-11.png"
              alt="Screenshot of Plexus App"
            />
          </figure>
        </div>
      </div>

      <!--- Fifth Image -->
      <div
        class="container-contents flex flex-wrap justify-between items-center mt-120 lg:mt-60 xl:pl-20 lg:pr-16"
      >
        <article class="w-full lg:w-2/4">
          <div class="container lg:w-10/12">
            <p class="article-paragraph lg:pr-5">
              We also added updates, which allows companies & admins to add
              company specific updates related to D&I. Consumers in-turn, see
              updates of companies they follow on their dashboard.
            </p>
          </div>
        </article>

        <div class="w-full flex justify-end lg:w-1/2 mt-16 lg:mt-0">
          <figure>
            <img
              class="object-cover object-center"
              src="../assets/images/plexus/plexus-12.png"
              alt="Screenshot of Plexus App"
            />
          </figure>
        </div>
      </div>

      <div class="container-contents mt-16 lg:mt-20">
        <div class="container mx-auto lg:w-2/3">
          <p class="article-paragraph text-green font-medium">
            We kept iterating on the visual design up until and even through
            development. <br />
            Development was done in milestones, with each milestone going
            through quality assurance before being deployed.
          </p>
        </div>
      </div>
    </section>

    <article
      class="py-20 lg:py-120 text-black-dark bg-white usability-testing from-beta"
    >
      <div class="container-contents">
        <div class="w-full lg:w-2/3 mx-auto">
          <h5 class="article-title">Recap & Takeaways</h5>
          <h6 class="article-title title-2 text-lg lg:text-2xl mt-6 lg:mt-8">
            Make Unique Offerings Stand Out & Easy to Access
          </h6>
          <p class="article-paragraph">
            A good amount of participants weren’t initially sure how Plexus
            differed from job boards and they weren’t willing to create an
            account to find out. Based on this, we designed Plexus to allow
            users to go as far as possible without needing to create an account.
            By the time users get to the point where they need to sign up, the
            value of Plexus is apparent.
          </p>
        </div>

        <div class="w-full lg:w-2/3 mx-auto mt-16 lg:mt-20">
          <h6 class="article-title title-2">
            Clarify Potential Areas of Confusion Where Possible
          </h6>
          <p class="article-paragraph">
            While testing, many participants wondered how ratings for companies
            would be generated. We curbed this by adding a few of the factors
            that go into ratings to the design. We also made sure the factors
            displayed are broad and easy to understand.
          </p>
        </div>
      </div>
    </article>

    <section class="mt-20 lg:mt-120">
      <div class="w-5/6 lg:w-2/3 mx-auto">
        <figure>
          <img
            src="../assets/images/plexus/plexus-1.png"
            alt="Screenshot of Plexus App"
          />
        </figure>

        <div class="mt-16 lg:mt-20 mx-auto text-center">
          <a
            href="https://plexus.tpinsights.com/"
            target="_blank"
            class="text-gray-lighter text-lg font-semibold text-center"
            >LEARN MORE ABOUT

            <div class="flex justify-center mt-6 lg:mt-8">
              <svg
                width="406"
                height="98"
                viewBox="0 0 406 98"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0)">
                  <rect
                    width="406"
                    height="98"
                    rx="3"
                    fill="white"
                    stroke="#303030"
                    stroke-width="4"
                  />
                  <path
                    d="M152.62 25C158.809 25 162.123 27.5963 162.123 32.5528C162.123 37.5094 158.809 40.1057 152.62 40.1057H145.792V51.7103H141V25H152.62ZM152.34 36.762C155.175 36.762 157.411 35.6212 157.411 32.5528C157.411 29.4845 155.175 28.3437 152.34 28.3437H145.792V36.762H152.34ZM166.236 51.7103V25H170.948V51.7103H166.236ZM191.232 44.6689L194.946 46.9505C193.309 50.3729 190.434 51.9857 185.842 51.9857C179.812 51.9857 175.62 47.6979 175.62 41.5219C175.62 35.1885 179.533 31.0187 185.442 31.0187C191.392 31.0187 194.786 35.3852 194.666 41.8759V42.1119H180.531C180.731 46.4391 182.847 48.996 186.241 48.996C188.357 48.996 190.633 48.0913 191.232 44.6689ZM185.442 34.0477C182.488 34.0477 180.97 36.1719 180.611 39.7517H189.555C189.356 35.7785 188.277 34.0477 185.442 34.0477ZM216.987 31.6087L209.121 41.4038L216.987 51.7103H211.716L206.685 44.6295L201.574 51.7103H196.623L204.409 41.7185L196.623 31.6087H201.894L206.845 38.4929L212.036 31.6087H216.987ZM233.838 31.6087H238.59V51.7103H233.838V47.5405C232.88 50.5302 231.003 52.025 227.609 52.025C223.216 52.025 220.621 49.9401 220.621 45.2196V31.6087H225.373V44.5902C225.373 47.5012 226.73 48.7993 229.326 48.7993C232.4 48.7993 233.798 46.7144 233.838 43.3707V31.6087ZM252.326 39.3583C257.796 40.5384 259.713 42.348 259.713 45.4556C259.713 49.3894 256.957 51.9857 251.607 51.9857C247.534 51.9857 243.82 49.7828 243.221 46.7144L246.536 44.7082C246.935 47.5012 249.091 48.996 251.886 48.996C254.562 48.996 255.44 47.9733 255.44 46.5571C255.44 44.8262 254.602 44.0788 251.208 43.4101C246.017 42.3873 243.82 40.5384 243.82 37.0767C243.82 33.6936 246.216 30.9793 252.126 30.94C256.359 30.9007 259.433 33.0642 259.952 36.1719L256.359 37.5094C255.959 35.0705 254.122 33.8903 251.567 33.8903C249.251 33.8903 247.933 34.7951 247.933 36.3686C247.933 38.0601 248.652 38.5715 252.326 39.3583ZM208.606 64.8998C210.021 64.8998 211.191 66.0028 211.191 67.7261C211.191 69.4603 210.027 70.5578 208.606 70.5578C207.749 70.5578 207.03 70.1353 206.69 69.4548L206.662 70.4426H205.632V62.0131H206.696L206.701 65.9754C207.047 65.3114 207.76 64.8998 208.606 64.8998ZM208.372 69.6578C209.342 69.6578 210.122 68.895 210.122 67.7261C210.122 66.5571 209.342 65.7998 208.372 65.7998C207.398 65.7998 206.623 66.6175 206.623 67.7261C206.623 68.8401 207.392 69.6578 208.372 69.6578ZM212.818 65.0095L214.339 69.1255L215.882 65.0095H217.007L213.77 73H212.667L213.804 70.3054L211.637 65.0095H212.818ZM261.957 64.5718C262.798 64.5718 263.34 64.9806 263.628 65.7073V64.7421H265V69.7951C265 71.6232 263.859 72.3158 262.13 72.3158C260.839 72.3158 259.952 71.8049 259.514 70.9305L260.689 70.3173C261.012 71.2371 261.438 71.521 262.28 71.521C263.271 71.521 263.628 70.8624 263.628 69.6474V68.8071C263.34 69.5452 262.775 69.9653 261.911 69.9653C260.482 69.9653 259.479 68.8071 259.479 67.2743C259.479 65.7186 260.493 64.5718 261.957 64.5718ZM236.134 64.5107C237.783 64.5107 238.748 65.7229 238.781 67.5464L238.781 67.8144H234.725C234.782 69.103 235.39 69.8645 236.364 69.8645C236.971 69.8645 237.624 69.595 237.796 68.5758L238.861 69.2552C238.392 70.2745 237.567 70.7548 236.249 70.7548C234.519 70.7548 233.316 69.4779 233.316 67.6386C233.316 65.7525 234.439 64.5107 236.134 64.5107ZM229.027 62.9497L229.027 65.96C229.27 65.1222 229.745 64.6969 230.622 64.6969C231.784 64.6969 232.523 65.4211 232.523 66.8005V70.7548H231.266V66.8924C231.266 66.0419 230.907 65.651 230.22 65.651C229.407 65.651 229.037 66.2718 229.027 67.2489V70.7548H227.77V62.9497H229.027ZM246.309 62.9497C248.166 62.9497 249.161 63.7083 249.161 65.1567C249.161 66.6051 248.166 67.3638 246.309 67.3638H244.261V70.7548H242.823V62.9497H246.309ZM251.538 62.9497V70.7548H249.953V62.9497H251.538ZM226.099 62.9868V63.952H223.673V70.6968H222.307V63.952H219.847V62.9868H226.099ZM254.523 64.7421V68.4892C254.523 69.3295 254.915 69.7042 255.664 69.7042C256.552 69.7042 256.955 69.1024 256.966 68.1372V64.7421H258.338V70.5444H256.966V69.3409C256.69 70.2038 256.148 70.6353 255.168 70.6353C253.901 70.6353 253.151 70.0335 253.151 68.6708V64.7421H254.523ZM262.291 65.4234C261.508 65.4234 260.943 66.1728 260.943 67.2743C260.943 68.353 261.508 69.1024 262.291 69.1024C263.075 69.1024 263.64 68.2962 263.64 67.2743C263.64 66.2523 263.075 65.4234 262.291 65.4234ZM236.134 65.4127C235.286 65.4127 234.851 66.0454 234.748 67.1115H237.315C237.257 65.9282 236.948 65.4127 236.134 65.4127ZM246.225 63.9268H244.261V66.3866H246.225C247.076 66.3866 247.747 66.0533 247.747 65.1567C247.747 64.2601 247.076 63.9268 246.225 63.9268Z"
                    fill="#191919"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="406" height="98" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </a>
        </div>
      </div>
    </section>

    <div class="mt-20 lg:h-60"></div>

    <div class="container-contents flex flex-col lg:flex-row justify-between">
      <div class="flex justify-center flex-col order-2 lg:order-1 mb-6 lg:mb-0">
        <p class="text-gray-lighter font-semibold text-center lg:text-left">
          PREVIOUS
        </p>
        <div class="flex justify-center items-center mt-6 lg:mt-8">
          <div class="w-full text-center lg:text-left relative">
            <a
              href="/timestudy"
              class="plexus-link-border outline-none focus:outline-none article-link text-green text-lg"
            >
              Time Study Now Case Study
            </a>
          </div>
        </div>
      </div>

      <div class="mb-20 lg:mb-0 order-1 lg:order-2">
        <p class="text-gray-lighter text-center lg:text-right font-semibold">
          NEXT
        </p>
        <div class="flex justify-center items-center mt-6 lg:mt-8">
          <div class="w-full text-center lg:text-left relative">
            <a
              href="/behold"
              class="plexus-link-border outline-none focus:outline-none article-link text-green text-lg"
            >
              Behold Case Study
            </a>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Logo from "@/components/Logo";
export default {
  name: "Pluxus",
  components: { Logo, Footer },
};
</script>

<style lang="scss" scoped>
.plexus-link-border {
  position: relative;
  text-decoration: none;

  &::before {
    background: #025955;
    bottom: -4px;
    left: 0;
    content: "";
    display: block;
    height: 3px;
    width: 100%;
    position: absolute;
  }
  &:hover {
    &::before {
      animation: line 0.95s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
    }
  }
}

.plexus-link-border:hover:before {
  animation: line 0.95s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}

@keyframes line {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
</style>
